import { useState } from "react";
import MobileDesignDocDetail from "./MobileDesignDocDetail";
import DesignDocVerUpload from "./DesignDocVerUpload";

export default function MobileDesignDocView({ docDetail, onReload }) {
  const [tab, setTab] = useState("detail"); // "detail" | "upload"

  if (!docDetail) return null;

  return (
    <div className="space-y-4">
      {/* 탭 메뉴 - 모바일 최적화 */}
      <div className="flex border-b">
        <div className="inline-flex space-x-2">
          <button
            onClick={() => setTab("detail")}
            className={`px-4 py-2 text-sm rounded-t-md transition ${tab === "detail"
                ? "bg-blue-50 text-blue-700 border-b-2 border-blue-600 font-semibold"
                : "text-gray-500 hover:text-gray-700"
              }`}
          >
            상세보기
          </button>
          <button
            onClick={() => setTab("upload")}
            className={`px-4 py-2 text-sm rounded-t-md transition ${tab === "upload"
                ? "bg-blue-50 text-blue-700 border-b-2 border-blue-600 font-semibold"
                : "text-gray-500 hover:text-gray-700"
              }`}
          >
            새 버전 업로드
          </button>
        </div>
      </div>

      {/* 탭 내용 */}
      <div className="pt-2">
        {tab === "detail" && <MobileDesignDocDetail docDetail={docDetail} />}
        {tab === "upload" && (
          <DesignDocVerUpload documentId={docDetail.id} onUploaded={onReload} />
        )}
      </div>
    </div>
  );
}
